import { createReducer } from "../utils";
import {
  TOGGLE_COMMENTS_WIDTH,
  TOGGLE_RELATED_SNAPSHOTS,
  SHOW_RELATED_SNAPSHOTS,
  TOGGLE_INFO_PANELS,
  SET_BACKGROUND_PREFERENCE,
  CHANGE_VIEW_MODE,
  SET_NOTIFICATION_EXCEPTIONS,
} from "../constants";
import { SNAPSHOTS } from "../constants/viewmodes";
import {
  _PENDING
} from '../constants/api';
import _ from "lodash";

const initialState = {
  commentsFullWidth: false,
  showRelatedSnapshots: true,
  infoPanels: {
    weather: true,
    calendar: true,
    information: true,
    partner: true,
    videos: true,
    blog: true,
    instagram: true,
    facts: true,
    qa: true
  },
  notificationExceptions: [],
  backgroundChoice: 'C',
  viewMode: _.get(window, '__initialState__.userPreferences.video_view_mode') || SNAPSHOTS
};

export default createReducer(initialState, {
  [TOGGLE_COMMENTS_WIDTH]: (state, payload) => {
    return Object.assign({}, state, {
      commentsFullWidth: payload.commentsFullWidth
    });
  },
  [TOGGLE_RELATED_SNAPSHOTS]: (state, payload) => {
    return Object.assign({}, state, {
      showRelatedSnapshots: !state.showRelatedSnapshots
    });
  },
  [SHOW_RELATED_SNAPSHOTS]: (state, payload) => {
    return Object.assign({}, state, {
      showRelatedSnapshots: true
    });
  },
  [TOGGLE_INFO_PANELS]: (state, payload) => {
    return Object.assign({}, state, {
      infoPanels: payload.data,
    });
  },
  [SET_NOTIFICATION_EXCEPTIONS]: (state, payload) => {
    return Object.assign({}, state, {
      notificationExceptions: payload.data,
    });
  },
  [SET_BACKGROUND_PREFERENCE]: (state, payload) => {
    return Object.assign({}, state, {
      backgroundChoice: payload.backgroundChoice
    });
  },
  [CHANGE_VIEW_MODE]: (state, payload) => {
    return Object.assign({}, state, {
      viewMode: payload.data
    });
  }
});
